<script>
export default {
  methods: {
    processContentEvent(eventData, lastMessageIdx, messageState) {   
      // 콘텐츠가 있는 경우 처리
      if (eventData.content) {
        // JSON 응답 시작을 감지
        if (this.isJsonResponseStart(eventData.content) && !messageState.isJsonResponse) {
          messageState.isJsonResponse = true;
          messageState.fullJsonText = ""; // JSON 텍스트 초기화
        }
        
        if (messageState.isJsonResponse) {
          this.processJsonContent(eventData.content, lastMessageIdx, messageState);
        } else {
          // 일반 텍스트 처리
          this.processPlainTextContent(eventData.content, lastMessageIdx, messageState);
        }
      } else if (eventData.message) {
        // message 필드로 전달된 텍스트 처리
        this.processPlainTextContent(eventData.message, lastMessageIdx, messageState);
      }
      
      // 콘텐츠가 비어있더라도 빈 메시지는 남기지 않기
      this.ensureNonEmptyMessage(lastMessageIdx);
    },
    
    ensureNonEmptyMessage(lastMessageIdx) {
      if (this.messages[lastMessageIdx - 1].text === "") {
        this.messages[lastMessageIdx - 1].text = " "; // 최소한 공백 한 칸이라도 추가
      }
    },
    
    isJsonResponseStart(content) {
      // JSON 형태로 시작하는지 확인
      try {
        // 중괄호로 시작하는 경우 체크
        if (content.trim().startsWith('{')) {
          // 완전한 JSON이 아니더라도 { 로 시작하고 " 문자가 포함되어 있다면 
          // JSON의 일부일 가능성이 높음
          if (content.includes('"')) {
            return true;
          }
        }
        
        // 완전한 JSON 객체인지 시도 (일부만 도착했어도 유효한 JSON일 수 있음)
        const parsed = JSON.parse(content);
        return typeof parsed === 'object' && parsed !== null;
      } catch (e) {
        // JSON 파싱에 실패하면 컨텐츠 특성 확인
        // 중괄호로 시작하고 키:값 형태가 있는지 정규식으로 확인
        if (content.trim().startsWith('{') && 
            /"\s*:\s*["{[]/.test(content)) {
          return true;
        }
        return false;
      }
    },
    
    processJsonContent(content, lastMessageIdx, messageState) {
      // JSON 데이터 누적
      messageState.fullJsonText += content;
      messageState.contentText += content;
      
      // 스트리밍 경험을 위한 텍스트 추출 및 표시
      if (messageState.fullJsonText.includes('"answer"')) {
        this.extractAndDisplayAnswer(lastMessageIdx, messageState);
      } else {
        this.messages[lastMessageIdx - 1].text = this.formatText(messageState.contentText);
      }
    },
    
    extractAndDisplayAnswer(lastMessageIdx, messageState) {
      try {
        // JSON 응답에서 답변 추출 시도
        const extractedContent = this.extractContentFromPartialJson(messageState.fullJsonText);
        if (extractedContent) {
          this.messages[lastMessageIdx - 1].text = extractedContent;
        } else {
          // 추출 실패 시 그냥 텍스트 표시
          this.messages[lastMessageIdx - 1].text = this.formatContentText(messageState.contentText);
        }
      } catch (e) {
        console.error("응답 추출 오류:", e);
        this.messages[lastMessageIdx - 1].text = this.formatText(messageState.contentText);
      }
    },
    
    formatContentText(text) {
      // 일단 JSON 파싱 시도
      const extractedContent = this.extractContentFromPartialJson(text);
      if (extractedContent) {
        return extractedContent;
      }
      
      // 파싱 실패 시 일반 텍스트 처리
      // 기본 정리
      return text
        .replace(/\u2028/g, "\n")
        .replace(/\\n/g, "\n")
        .replace(/^.*?{.*?":\s*"?/i, '') // 첫 번째 키-값 쌍의 시작 부분 제거 (안전하게)
        .replace(/"\s*,\s*"[^"]+"\s*:.*$/i, ''); // 다음 키-값 쌍 시작 전까지 자르기 (안전하게)
    },
    
    // 부분 JSON에서 응답 내용 추출
    extractContentFromPartialJson(jsonText) {
      try {
        // 1단계: 완전한 JSON 객체인지 확인
        try {
          const parsed = JSON.parse(jsonText);
          // 가능한 응답 필드 이름들
          const possibleKeys = ['answer', 'content', 'text', 'message', 'response', 'result'];
          
          // 가능한 필드들 중에서 값을 찾음
          for (const key of possibleKeys) {
            if (parsed[key] !== undefined && typeof parsed[key] === 'string') {
              return this.formatText(parsed[key]);
            }
          }
          
          // 없으면 첫 번째 문자열 값 찾기
          for (const key in parsed) {
            if (typeof parsed[key] === 'string' && key !== 'contact' && key !== 'type') {
              return this.formatText(parsed[key]);
            }
          }
        } catch (parseError) {
          // 완전한 JSON이 아닌 경우 진행
        }
        
        // 2단계: 부분적인 JSON 처리를 위해 중괄호로 닫아보기
        try {
          // 여는 중괄호로 시작하는지 확인
          if (jsonText.trim().startsWith('{')) {
            // 닫는 중괄호가 없거나 위치가 잘못된 경우 추가
            const balancedText = this.balanceJsonBraces(jsonText);
            const parsed = JSON.parse(balancedText);
            
            // 위와 같은 방식으로 필드 검색
            const possibleKeys = ['answer', 'content', 'text', 'message', 'response', 'result'];
            for (const key of possibleKeys) {
              if (parsed[key] !== undefined && typeof parsed[key] === 'string') {
                return this.formatText(parsed[key]);
              }
            }
            
            // 없으면 첫 번째 문자열 값 찾기
            for (const key in parsed) {
              if (typeof parsed[key] === 'string' && key !== 'contact' && key !== 'type') {
                return this.formatText(parsed[key]);
              }
            }
          }
        } catch (balanceError) {
          // 중괄호 밸런싱 실패 시 진행
        }
        
        return null;
      } catch (e) {
        console.error("JSON 응답 추출 오류:", e);
        return null;
      }
    },
    
    // 모든 텍스트 포맷팅에 사용할 공통 메서드
    formatText(text) {
      if (!text) return '';
      
      // 줄바꿈 처리
      text = text.replace(/\u2028/g, "\n").replace(/\\n/g, "\n");
      
      // HTML escape 처리
      return this.escapeHtml(text);
    },
    
    // HTML 이스케이프 처리 메소드
    escapeHtml(text) {
      return text
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    },
    
    processPlainTextContent(content, lastMessageIdx, messageState) {
      console.log('일반 텍스트 청크 추가:', content);
      messageState.contentText += content;
      this.messages[lastMessageIdx - 1].text = this.formatText(messageState.contentText);
    },
    
    processFinalJsonResponse(lastMessageIdx, messageState) {
      try {
        // 올바른 JSON 형식으로 정리
        messageState.fullJsonText = this.sanitizeJsonString(messageState.fullJsonText);
        
        console.log('파싱 시도할 최종 JSON:', messageState.fullJsonText);
        const contentJson = JSON.parse(messageState.fullJsonText);
        console.log('complete: 파싱된 JSON 콘텐츠:', contentJson);
        
        // 파싱 성공 시 데이터 설정
        this.updateMessageFromJson(lastMessageIdx, contentJson);
      } catch (e) {
        console.error("최종 JSON 파싱 오류:", e, "누적된 JSON:", messageState.fullJsonText);
        
        // 파싱 실패 시 텍스트 기반 필드 추출
        this.extractDataFromFailedJsonParsing(lastMessageIdx, messageState);
      }
    },
    
    // 파싱된 JSON에서 메시지를 업데이트하는 공통 메서드
    updateMessageFromJson(lastMessageIdx, contentJson) {
      // 텍스트 업데이트
      if (contentJson.answer) {
        this.messages[lastMessageIdx - 1].text = this.formatText(contentJson.answer);
      }
      
      // contact 필드 업데이트
      if (contentJson.contact !== undefined) {
        this.messages[lastMessageIdx - 1].wantContact = contentJson.contact.toString();
      }
      
      // references 필드 업데이트
      if (contentJson.references && Array.isArray(contentJson.references)) {
        this.messages[lastMessageIdx - 1].referenceFaqIds = contentJson.references.join(',');
      }
    },
    
    extractDataFromFailedJsonParsing(lastMessageIdx, messageState) {
      // 파싱 실패 시 텍스트에서 필드 추출 시도
      const extractedContent = this.extractContentFromPartialJson(messageState.fullJsonText);
      if (extractedContent) {
        this.messages[lastMessageIdx - 1].text = extractedContent;
      } else if (messageState.contentText) {
        // 추출 실패 시 누적된 텍스트를 처리
        this.messages[lastMessageIdx - 1].text = this.formatContentText(messageState.contentText);
      }
      
      // 다른 필드들도 유연하게 추출 시도
      this.extractAdditionalFields(lastMessageIdx, messageState.fullJsonText);
    },
    
    extractAdditionalFields(lastMessageIdx, fullJsonText) {
      try {
        // JSON 파싱 시도
        let parsed;
        try {
          parsed = JSON.parse(fullJsonText);
        } catch (e) {
          try {
            // 밸런싱 후 다시 시도
            const balancedText = this.balanceJsonBraces(fullJsonText);
            parsed = JSON.parse(balancedText);
          } catch (e2) {
            // 파싱 실패 시 기존 방식으로 fallback
            this.extractContactField(lastMessageIdx, fullJsonText);
            this.extractReferencesField(lastMessageIdx, fullJsonText);
            return;
          }
        }
        
        // contact 필드 또는 유사 필드 처리
        const contactFields = ['contact', 'needContact', 'wantContact', 'requireContact'];
        for (const field of contactFields) {
          if (parsed[field] !== undefined) {
            this.messages[lastMessageIdx - 1].wantContact = parsed[field].toString();
            break;
          }
        }
        
        // references 필드 또는 유사 필드 처리
        const referencesFields = ['references', 'referenceIds', 'faqIds', 'relatedFaqs'];
        for (const field of referencesFields) {
          if (parsed[field] !== undefined && Array.isArray(parsed[field])) {
            this.messages[lastMessageIdx - 1].referenceFaqIds = parsed[field].join(',');
            break;
          }
        }
      } catch (e) {
        console.error("추가 필드 추출 오류:", e);
        // 오류 발생 시 기존 방식으로 fallback
        this.extractContactField(lastMessageIdx, fullJsonText);
        this.extractReferencesField(lastMessageIdx, fullJsonText);
      }
    },
    
    extractContactField(lastMessageIdx, fullJsonText) {
      if (fullJsonText.includes('"contact":true')) {
        this.messages[lastMessageIdx - 1].wantContact = "true";
      } else if (fullJsonText.includes('"contact":false')) {
        this.messages[lastMessageIdx - 1].wantContact = "false";
      }
    },
    
    extractReferencesField(lastMessageIdx, fullJsonText) {
      const referencesMatch = fullJsonText.match(/"references":\[([^\]]*)\]/);
      if (referencesMatch && referencesMatch[1]) {
        const referenceIds = referencesMatch[1].split(',')
          .map(id => id.trim())
          .filter(id => /^\d+$/.test(id));
        if (referenceIds.length > 0) {
          this.messages[lastMessageIdx - 1].referenceFaqIds = referenceIds.join(',');
        }
      }
    },
    
    processFinalPlainResponse(eventData, lastMessageIdx) {
      // 기존 콘텐츠가 없고 최종 콘텐츠가 있는 경우에만 처리
      // JSON 형태의 응답인지 확인
      const isJsonString = typeof eventData.content === 'string' && 
          eventData.content.trim().startsWith('{') && 
          eventData.content.trim().endsWith('}');

      if (isJsonString) {
        try {
          // JSON 파싱
          const contentJson = JSON.parse(eventData.content);
          console.log('complete: 파싱된 JSON 콘텐츠:', contentJson);
          
          this.updateMessageFromJson(lastMessageIdx, contentJson);
        } catch (e) {
          console.error("최종 응답 JSON 파싱 오류:", e, "원본 콘텐츠:", eventData.content);
          // JSON 파싱에 실패했을 경우 일반 텍스트로 처리
          this.messages[lastMessageIdx - 1].text = this.formatText(eventData.content);
        }
      } else {
        // 일반 텍스트 처리
        console.log('complete: 일반 텍스트 설정:', eventData.content);
        this.messages[lastMessageIdx - 1].text = this.formatText(eventData.content);
      }
    },
    
    // JSON 중괄호 밸런싱을 맞추는 헬퍼 메서드
    balanceJsonBraces(text) {
      // 중괄호 수 확인
      const openBraces = (text.match(/\{/g) || []).length;
      const closeBraces = (text.match(/\}/g) || []).length;
      
      // 닫는 중괄호가 부족한 경우 추가
      if (openBraces > closeBraces) {
        return text + '}'.repeat(openBraces - closeBraces);
      }
      
      return text;
    },
    
    // JSON 문자열 정리 및 유효한 JSON으로 만들기
    sanitizeJsonString(jsonText) {
      try {
        // 시작 부분에 { 가 없으면 추가
        if (!jsonText.includes('{')) {
          const firstQuoteIndex = jsonText.indexOf('"');
          if (firstQuoteIndex > -1) {
            jsonText = '{' + jsonText.substring(firstQuoteIndex);
          }
        }
        
        // 자르고 싶은 패턴들 찾기 (JSON 끝 감지)
        const patterns = ['"}', '"]}'];
        let endIndex = jsonText.length;
        
        for (const pattern of patterns) {
          const idx = jsonText.lastIndexOf(pattern);
          if (idx > -1) {
            const candidateEndIndex = idx + pattern.length;
            if (candidateEndIndex < endIndex) {
              endIndex = candidateEndIndex;
            }
          }
        }
        
        // 필요한 경우 텍스트 자르기
        if (endIndex < jsonText.length) {
          jsonText = jsonText.substring(0, endIndex);
        }
        
        // 닫는 중괄호가 없으면 추가
        if (!jsonText.endsWith('}')) {
          jsonText += '}';
        }
        
        // 만약 "answer": 다음에 "가 누락된 경우 추가
        jsonText = jsonText.replace(/"answer":\s*([^"])/g, '"answer":"$1');
        
        // "contact":true 패턴이 오타난 경우 수정
        jsonText = jsonText.replace(/"contact":(true|false)\s*([^,}])/g, '"contact":$1,$2');
        
        // 이중 콤마 제거
        jsonText = jsonText.replace(/,,/g, ',');
        
        return jsonText;
      } catch (e) {
        console.error("JSON 문자열 정리 오류:", e);
        return jsonText; // 오류 발생 시 원본 반환
      }
    }
  }
}
</script> 